import { useState } from 'react';

export interface ListState {
  page: number;
  search: string;
  sort: string | undefined;
  order: 'asc' | 'desc';
}

/** Search, sort and paging state for a list page. Changing search or filters goes back to page 1. */
export function useListState(initial: Partial<ListState> = {}) {
  const [state, setState] = useState<ListState>({ page: 1, search: '', sort: undefined, order: 'asc', ...initial });
  return {
    ...state,
    setPage: (page: number) => setState((s) => ({ ...s, page })),
    setSearch: (search: string) => setState((s) => ({ ...s, search, page: 1 })),
    resetPage: () => setState((s) => ({ ...s, page: 1 })),
    toggleSort: (field: string) =>
      setState((s) => ({
        ...s,
        page: 1,
        sort: field,
        order: s.sort === field && s.order === 'asc' ? 'desc' : 'asc',
      })),
  };
}
